import { EstateType } from './estate-type.enum';
import { Portal } from './portal.enum';

export enum EstateSubType {
    Apartment = 'Apartment',
    Bungalow = 'Bungalow',
    Chalet = 'Chalet',
    DuplexOrTriplex = 'DuplexOrTriplex',
    EndTerraceHouse = 'EndTerraceHouse',
    House = 'House',
    Loft = 'Loft',
    Mansion = 'Mansion',
    MultiFamilyHouse = 'MultiFamilyHouse',
    Penthouse = 'Penthouse',
    SemiDetachedHouse = 'SemiDetachedHouse',
    SingleFamilyHouse = 'SingleFamilyHouse',
    Studio = 'Studio',
    TerraceHouse = 'TerraceHouse',
    TownHouse = 'TownHouse',
    Villa = 'Villa',
}

export enum GermanEstateSubTypeApartment {
    Apartment = 'Apartment',
    DuplexOrTriplex = 'DuplexOrTriplex',
    Penthouse = 'Penthouse',
}

export enum GermanEstateSubTypeHouse {
    EndTerraceHouse = 'EndTerraceHouse',
    MultiFamilyHouse = 'MultiFamilyHouse',
    TerraceHouse = 'TerraceHouse',
    SemiDetachedHouse = 'SemiDetachedHouse',
    SingleFamilyHouse = 'SingleFamilyHouse',
}

export enum BelgianEstateSubTypeApartment {
    Apartment = 'Apartment',
    DuplexOrTriplex = 'DuplexOrTriplex',
    Loft = 'Loft',
    Penthouse = 'Penthouse',
    Studio = 'Studio',
}

export enum BelgianEstateSubTypeHouse {
    Bungalow = 'Bungalow',
    Chalet = 'Chalet',
    House = 'House',
    Mansion = 'Mansion',
    TownHouse = 'TownHouse',
    Villa = 'Villa',
}

export enum FrenchEstateSubTypeApartment {
    Apartment = 'Apartment',
    DuplexOrTriplex = 'DuplexOrTriplex',
    Loft = 'Loft',
}

export enum FrenchEstateSubTypeHouse {
    House = 'House',
    Mansion = 'Mansion',
}

// White-labelized estate-subtypes type
type TWLEstateSubType =
    | typeof GermanEstateSubTypeApartment
    | typeof BelgianEstateSubTypeApartment
    | typeof GermanEstateSubTypeHouse
    | typeof BelgianEstateSubTypeHouse
    | typeof FrenchEstateSubTypeApartment
    | typeof FrenchEstateSubTypeHouse;

// @ts-expect-error Apply a minor change on v1. will be removed at v2
export const PORTAL_TO_ESTATE_SUBTYPE: Record<Portal, Record<EstateType, TWLEstateSubType>> = {
    [Portal.ImmoWeb]: {
        [EstateType.Apartment]: BelgianEstateSubTypeApartment,
        [EstateType.House]: BelgianEstateSubTypeHouse,
    },
    [Portal.ImmoWelt]: {
        [EstateType.Apartment]: GermanEstateSubTypeApartment,
        [EstateType.House]: GermanEstateSubTypeHouse,
    },
    [Portal.Immonet]: {
        [EstateType.Apartment]: GermanEstateSubTypeApartment,
        [EstateType.House]: GermanEstateSubTypeHouse,
    },
    [Portal.SeLoger]: {
        [EstateType.Apartment]: FrenchEstateSubTypeApartment,
        [EstateType.House]: FrenchEstateSubTypeHouse,
    },
    [Portal.LogicImmo]: {
        [EstateType.Apartment]: FrenchEstateSubTypeApartment,
        [EstateType.House]: FrenchEstateSubTypeHouse,
    },
};
